// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"d1cc6bee431f0c03524d","532":"88ee39689fa574a76a9b","678":"bcfd6e2eabf4b88dde04","883":"e6c85e219d7eb5d566a5"}[chunkId] + ".js";
};